import { getLocalizedNameByLocale } from '@mfw/components';

import type {
  ApiTranslation,
  UiTranslation,
} from '../../schemas/translations.schema';

export function mapTranslationFromApi(
  translation: ApiTranslation,
): UiTranslation {
  return {
    locale: [
      {
        label: getLocalizedNameByLocale(translation.locale),
        value: translation.locale,
      },
    ],
    name: translation.name,
  };
}

export function mapTranslationsFromApi(
  translations: ApiTranslation[],
): UiTranslation[] {
  return translations.map(mapTranslationFromApi);
}
